
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[[...segments]]",
      function () {
        return require("private-next-pages/blog/[[...segments]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[[...segments]]"])
      });
    }
  